<template>
    <v-layout column>
        <v-flex class="primary lighten-1 py-3 px-4 white--text" style="font-size: 20px;">
            {{title}}
        </v-flex>
        <v-flex>
            <v-layout>

            
                    <v-flex class="px-2 py-2">
                        
                        <v-card class="">
                            <v-card-title><h3>Filters</h3></v-card-title>
                            <v-card-text>
                                <v-layout>
                                    <v-flex class="mx-5">
                                        <date-picker label="Vanaf" v-model="fromDate"></date-picker>
                                    </v-flex>
                                    <v-flex class="mx-5">
                                        <date-picker label="Tot" v-model="tillDate"></date-picker>
                                    </v-flex>
                                </v-layout>
                                <v-flex class="mx-5">
                                    <v-layout>
                                        <v-flex sm6 lg3>
                                            <v-checkbox label="Alle groepen" v-model="allGroups"></v-checkbox>
                                        </v-flex>
                                        <v-flex>
                                            <v-select
                                                v-model="selectedGroups"
                                                :items="assetGroups"
                                                label="Groepen"
                                                item-text="name"
                                                item-value="id"
                                                multiple
                                                :disabled="allGroups"
                                            >
                                            </v-select>
                                        </v-flex>
                                        
                                    </v-layout>
                                        
                                    
                                    
                                </v-flex>
                                <v-flex   style="justify-content: flex-end; display:flex;">
                                    <v-btn class="accent mx-5 mt-4"  @click="generateReport">Zoeken</v-btn>
                                </v-flex>                                                                
                            </v-card-text>
                            
                        </v-card>
                    </v-flex>
                    <v-flex class="px-2 py-2 d-flex" sm12 md6 lg6>
                        
                        <v-card>
                            <v-card-title><h3>Totalen</h3></v-card-title>
                            <v-card-text d-flex>
                                <v-layout>
                                    <v-flex class="d-flex" style="min-height:100px;">
                                        <div class="dd-status-legend-item" :style="`border-left-color: ${item.color}`" v-for="item of seriesAverageAggregate" :key="item.name">
                                            <div class="dd-status-legend-title">{{item.name}}</div>
                                            <div class="dd-status-legend-number">{{(item.value).toFixed(1)}}%</div>
                                        </div>   
                                    </v-flex>
                                </v-layout>
                                
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-layout>                
                        <v-flex class="px-2 py-2" sm12 md12 :class="(graphs.length == 1) ? 'xl12' : 'xl6'" v-for="(graph, i) of graphs" :key="i">                            
                            <v-card >
                                <v-card-title>
                                    <h3>{{graph.title}} </h3>
                                </v-card-title>
                                <v-card-text>
                                    <line-chart :xAxis="graph.legend" :series="graph.series" :title="graph.title"></line-chart>
                                </v-card-text>
                            </v-card>
                            
                        </v-flex>
                        
                    
                </v-layout>
            </v-flex>
            <v-flex>

            </v-flex>
    </v-layout>
    
</template>
<script>
import DatePicker from '../../components/form/DatePicker'
import * as types from '../../store/types'
import { mapGetters } from 'vuex'
import { apiRequest } from '../../plugins/core/dd.data.connect'
import LineChart from '../../components/report/LineChart'
import SmallDashboardCard from '../../components/graph/SmallDashboardCard'
import AnimatedNumber from "animated-number-vue";

import moment from 'moment'

export default {
    components: {DatePicker, LineChart, SmallDashboardCard,AnimatedNumber},
    data(){        
        return {
            picker: null,
            fromDate:null, 
            tillDate:null,
            allGroups: true,
            selectedGroups: [],
            title: '',
            report: null,
            graphs: []
        }
    },
    watch:{
        selectedGroups(nv){
            //console.log(nv)
            if(nv.find(ele => ele.id === 0)){                
                //console.log("KEK")
                nv = []
                
            }
            if(nv.length == this.selectedGroups){

            }
            return nv
            
        }
    },
    methods:{
        generateReport(){
            let vm = this
            if(this.allGroups){
                this.selectedGroups = []
            }
            if(this.report == 'deployment'){
                apiRequest('GET', '/reports/deployment', null, { groups: this.selectedGroups, from: this.fromDate, till:this.tillDate }).then((result) => {
                    //console.log("INFO BINNEN!", result)
                    let series = []
                    this.graphs = []
                    // get the serie legend
                    let legend
                    
                    if(this.allGroups){
                        legend = Object.keys(result.data.all.data.own_location)                        
                        let serie = {
                            name: 'Eigen locatie',  
                            internalName: 'own',
                            data: [], 
                            'type': 'line',
                            lineStyle: {
                                width: 8,
                            },
                            color: '#2196F3'
                        }
                        for(let i in result.data.all.data['own_location']){
                            // create a serie
                            let ele = result.data.all.data['own_location'][i]
                            serie.data.push(((ele.appliedUnits / ele.totalUnits) * 100).toFixed(1))                                                                        
                        }
                        series.push(serie)




                        serie = {
                            name: 'Klant locatie',  
                            internalName: 'customer',
                            data: [], 
                            'type': 'line',
                            lineStyle: {
                                width: 8,
                            },
                            color: '#CDDC39'
                        }
                        for(let i in result.data.all.data['customer_location']){
                            // create a serie
                            let ele = result.data.all.data['customer_location'][i]
                            serie.data.push(((ele.appliedUnits / ele.totalUnits) * 100).toFixed(1))                                                                        
                        }
                        series.push(serie)

                        
                        
                        
                        
                        serie = {
                            name: 'Overige',  
                            internalName: 'default',
                            data: [], 
                            'type': 'line',
                            lineStyle: {
                                width: 8,
                            },
                            color: '#9C27B0'
                        }
                        for(let i in result.data.all.data['default']){
                            // create a serie
                            let ele = result.data.all.data['default'][i]
                            serie.data.push(((ele.appliedUnits / ele.totalUnits) * 100).toFixed(1))                                                                        
                        }
                        series.push(serie)
                        this.graphs.push({title: `Inzet (Totalen)`, series: series, legend: legend})
                    }
                    else{
                        
                        for(let groupId in result.data){                            
                            if(result.data[groupId].data.own_location)
                            {
                                
                                legend = Object.keys(result.data[groupId].data.own_location)
                            //  console.log(result.data['own_location'])
                                let serie = {
                                    name: 'Eigen locatie', 
                                    internalName: 'own',
                                    data: [], 
                                    'type': 'line',
                                    lineStyle: {
                                        width: 8,
                                    },
                                    color: '#2196F3'
                                }
                                for(let i in result.data[groupId].data['own_location']){
                                    // create a serie
                                    let ele = result.data[groupId].data['own_location'][i]
                                    serie.data.push(((ele.appliedUnits / ele.totalUnits) * 100).toFixed(1))                                                                        
                                }
                                series.push(serie)




                                serie = {
                                    name: 'Klant locatie',  
                                    internalName: 'customer',
                                    data: [], 
                                    'type': 'line',
                                    lineStyle: {
                                        width: 8,
                                    },
                                    color: '#CDDC39'
                                }
                                for(let i in result.data[groupId].data['customer_location']){
                                    // create a serie
                                    let ele = result.data[groupId].data['customer_location'][i]
                                    serie.data.push(((ele.appliedUnits / ele.totalUnits) * 100).toFixed(1))                                                                        
                                }
                                series.push(serie)

                                
                                
                                
                                
                                serie = {
                                    name: 'Overige',  
                                    internalName: 'default',
                                    data: [], 
                                    'type': 'line',
                                    lineStyle: {
                                        width: 8,
                                    },
                                    color: '#9C27B0'
                                }
                                for(let i in result.data[groupId].data['default']){
                                    // create a serie
                                    let ele = result.data[groupId].data['default'][i]
                                    serie.data.push(((ele.appliedUnits / ele.totalUnits) * 100).toFixed(1))                                                                        
                                }
                                series.push(serie)
                                
                                this.graphs.push({title: `Inzet (${result.data[groupId].name})`, series: series, legend: legend})
                                series = []
                            }
                        }                        
                    }
                    
                    //console.log(series)
                    
                })
            }
        },
        loadDeployment(){
            this.title = "Inzetgraad rapportage"
            this.report = 'deployment'
            

        }
    },
    computed:{
        ...mapGetters({
            assetGroups: types.ASSET_GROUPS,
            
        }),
        seriesAverageAggregate(){
            if(this.graphs && this.graphs[0] && this.graphs[0].legend){
                // per serie name over all graphs
                if(this.report == 'deployment'){
                    let ownLocation = 0;
                    let customerLocation = 0;
                    let defaultLocation = 0; 

                    for(let i in this.graphs){
                        let graph = this.graphs[i]
                        console.log("bur", graph)
                        if(graph.series && graph.series[0].data && graph.series[0].data.length > 0){                            
                            // ownLocation = ownLocation + graph.series.find((ele) => ele.internalName == 'own').data.map((e) => {                                
                            //     return parseFloat(e)
                            // }).reduce((total, value) => {                                
                            //     return parseFloat(total) + parseFloat(value)
                            // })

                            let clacc = graph.series.find((ele) => ele.internalName == 'own')
                            if(clacc.data.length > 0){
                                    ownLocation = ownLocation +  clacc.data.map((e) => {                                
                                    return parseFloat(e)
                                }).reduce((total, value) => {                                
                                    return parseFloat(total) + parseFloat(value)
                                })
                            }

                            clacc = graph.series.find((ele) => ele.internalName == 'customer')
                            if(clacc.data.length > 0){
                                    customerLocation = customerLocation +  clacc.data.map((e) => {                                
                                    return parseFloat(e)
                                }).reduce((total, value) => {                                
                                    return parseFloat(total) + parseFloat(value)
                                })
                            }

                            clacc = graph.series.find((ele) => ele.internalName == 'default')
                            if(clacc.data.length > 0){
                                    defaultLocation = defaultLocation +  clacc.data.map((e) => {                                
                                    return parseFloat(e)
                                }).reduce((total, value) => {                                
                                    return parseFloat(total) + parseFloat(value)
                                })
                            }
                            
                               
                           
                        }                        
                    }

                    let totalOwnLocation = (ownLocation / this.graphs[0].legend.length) 
                    let totalCustomerLocation = (customerLocation / this.graphs[0].legend.length) 
                    let totalDefaultLocation = (defaultLocation / this.graphs[0].legend.length) 
                    
                    return [
                        {   
                            name: 'Eigen locatie',
                            value: totalOwnLocation,
                            color: '#2196F3' 
                        },
                        {   
                            name: 'Klant locatie',
                            value: totalCustomerLocation,
                            color: '#CDDC39' 
                        },
                        {   
                            name: 'Overige locaties',
                            value: totalDefaultLocation,
                            color: '#9C27B0' 
                        }                                            
                    ]                    
                }
            }
        }
        // sortedGroups(){
        //     let ags = this.assetGroups.splice(0)
        //     ags.unshift({name: 'Alle groepen', id: 0})
        //     return ags
        // }
    },
    mounted(){
        this.$store.dispatch(types.ASSET_GROUPS, {params: {}})
        this.fromDate = moment().subtract(1, 'months').format('YYYY-MM-DD')
        
        if(this.$route.path == '/reports/deployment'){
            this.loadDeployment()
        }
    }
}
</script>
<style>

</style>